import { useContext } from "react"
import { CadastroPromocaoFidelidadeContext } from "./CadastroPromocaoFidelidadeContext"

export function useCadastroPromocaoFidelidadeContext() {
    return useContext(CadastroPromocaoFidelidadeContext)
}
